module.exports = __webpack_public_path__ + "img/kba-export-exported.8b0c9a9f.svg";